document.addEventListener("DOMContentLoaded", () => {

  const drawer = document.querySelector("#CartDrawer");
  const overlay = drawer.querySelector(".syg-drawer__overlay");
  const closeBtn = drawer.querySelector(".syg-drawer__close");

  function openDrawer() {
    drawer.classList.add("open");
  }

  function closeDrawer() {
    drawer.classList.remove("open");
  }

  overlay.addEventListener("click", closeDrawer);
  closeBtn.addEventListener("click", closeDrawer);

  // 加减数量
  document.querySelectorAll(".qty").forEach(input => {
    input.addEventListener("change", async (e) => {
      const key = e.target.dataset.key;
      const qty = e.target.value;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          id: key,
          quantity: qty
        })
      });

      location.reload();
    });
  });

  // 删除
  document.querySelectorAll(".remove").forEach(btn => {
    btn.addEventListener("click", async (e) => {
      const key = e.target.dataset.key;

      await fetch("/cart/change.js", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          id: key,
          quantity: 0
        })
      });

      location.reload();
    });
  });

  // 监听购物车按钮（自动打开）
  document.querySelectorAll('a[href="/cart"]').forEach(btn => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openDrawer();
    });
  });

});
document.addEventListener("DOMContentLoaded", () => {
  const drawer = document.querySelector(".syg-drawer");
  const openBtn = document.querySelector(".cart-open"); // 你按钮
  const closeBtn = document.querySelector(".syg-drawer__close");
  const overlay = document.querySelector(".syg-drawer__overlay");

  function openCart() {
    drawer.classList.add("active");
  }

  function closeCart() {
    drawer.classList.remove("active");
  }

  openBtn?.addEventListener("click", openCart);
  closeBtn?.addEventListener("click", closeCart);
  overlay?.addEventListener("click", closeCart);
});